__webpack_require__.p = "https://cdn-assessment.mathletics.com/app/100/";